"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.INFO_AND_BENEFITS = exports.INFO = exports.BENEFIT = void 0;
const BENEFIT = exports.BENEFIT = 'benefit';
const INFO = exports.INFO = 'info';
const INFO_AND_BENEFITS = exports.INFO_AND_BENEFITS = 'info-and-benefits';
